import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
// import Show from '../views/Show.vue'

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  // {
  //   path: '/show',
  //   name: 'Show',
  //   component: Show,
  //   children: [{
  //       path: '/',
  //       name: 'Electronics',
  //       component: () => import( /* webpackChunkName: "about" */ '../views/show/Electronics.vue')
  //     },
  //     {
  //       path: '/show/assemble',
  //       name: 'Assemble',
  //       component: () => import( /* webpackChunkName: "about" */ '../views/show/Assemble.vue')
  //     },
  //     {
  //       path: '/show/molding',
  //       name: 'Molding',
  //       component: () => import( /* webpackChunkName: "about" */ '../views/show/Molding.vue')
  //     }
  //   ]
  // },
  // {
  //   path: '/videoList',
  //   name: 'VideoList',
  //   component: () => import( /* webpackChunkName: "about" */ '../views/VideoList.vue'),
  //   children: [{
  //       path: '/',
  //       name: 'App',
  //       component: () => import( /* webpackChunkName: "about" */ '../views/video/App.vue')
  //     },
  //     {
  //       path: '/videoList/bs',
  //       name: 'Bs',
  //       component: () => import( /* webpackChunkName: "about" */ '../views/video/Bs.vue')
  //     },
  //     {
  //       path: '/videoList/cs',
  //       name: 'Cs',
  //       component: () => import( /* webpackChunkName: "about" */ '../views/video/Cs.vue')
  //     },
  //     {
  //       path: '/videoList/product',
  //       name: 'Product',
  //       component: () => import( /* webpackChunkName: "about" */ '../views/video/Product.vue')
  //     }
  //   ]
  // },
  {
    path: "/system",
    name: "System",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ "../views/System.vue"),
  },
  {
    path: "/screen",
    name: "Screen",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ "../views/Screen.vue"),
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savePosition) {
    if (savePosition) {
      return savePosition;
    } else {
      return {
        x: 0,
        y: 0,
      };
    }
  },
});
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};
export default router;
